module.exports = __webpack_public_path__ + "static/media/assessment-icon.87c45d2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment-icon.svg
// module id = 526
// module chunks = 0